import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">Products</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">More Categories</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              {categories.slice(4, 8).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">Shopping Guides</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              {articles.slice(0, 4).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {article.title.length > 28 ? article.title.slice(0, 28) + "..." : article.title}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">Quick Links</h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer transition-colors">Main Website</a>
              {categories.slice(12).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 whitespace-nowrap">Pandabuy<span className="font-light">Sheet</span></p>
            <p className="text-xs text-foreground-500 mt-1">Independent fashion data for smarter shopping.</p>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 cursor-pointer transition-colors" aria-label="Instagram">
              <i className="ri-instagram-line text-base"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 cursor-pointer transition-colors" aria-label="TikTok">
              <i className="ri-tiktok-line text-base"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 cursor-pointer transition-colors" aria-label="Pinterest">
              <i className="ri-pinterest-line text-base"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 cursor-pointer transition-colors" aria-label="Twitter">
              <i className="ri-twitter-x-line text-base"></i>
            </a>
          </div>
        </div>
        <p className="text-xs text-foreground-400 mt-4 text-right">Pandabuy Sheet is an independent fashion research platform. All external links direct to our partner spreadsheet service.</p>
      </div>
    </footer>
  );
}